import React from 'react';
import { connect } from 'react-redux';
import * as Constants from '../../Common/constants.js';
import PlayerItem from '../PlayerItem/PlayerItem.js';
import PlayerGroupItem from './PlayerGroupItem.js';

class Tournament extends React.Component {

    constructor(props) {

        super(props);

        this.state = { data: null, serverErrors: {} };
        this.selectPlayer = this.selectPlayer.bind(this);
        this.selectPlayerGroup = this.selectPlayerGroup.bind(this);
    }
    static getDerivedStateFromProps(props, state) {
        console.info('Tournament - getDerivedStateFromProps called.');
        // if (!state.data || !state.data.leaderboard) {
        //     return state;
        // }

        // var lastEvent = props.leaderboardData.last;
        // if (!lastEvent) {
        //     return state;
        // }
        // var oldLastEvent = state.data.leaderboard.events && state.data.leaderboard.events.length > 0 ? state.data.leaderboard.events[0] : null;

        // if (!oldLastEvent) {
        //     state.data.leaderboard.events.push(lastEvent);
        // } else
        //     if (lastEvent && lastEvent.id != oldLastEvent.id) {
        //         state.data.leaderboard.events.unshift(lastEvent);
        //     }

        return state;


    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        console.info('Tournament - getSnapshotBeforeUpdate called.');
        return null;
    }



    componentDidMount() {
        console.info('Tournament - componentDidMount called.');
        console.log(this.props.location.search);
        var start = this.props.location.search.indexOf("id=");
        var end = this.props.location.search.indexOf("&", start);

        var id = null;

        if (start > 0 && end > 0) {

            id = this.props.location.search.slice(start + 3, end);

        } else if (start > 0) {

            id = this.props.location.search.slice(start + 3);

        }else {
            id = Constants.LEADERBOARD_ID;
        }
        this._tid = id;
        this.fetchTournament(id);
    }



    shouldComponentUpdate() {
        console.info('Tournament - shouldComponentUpdate.');
        return true;
    }


    componentDidUpdate() {
    }

    componentWillUnmount() {

    }



    render() {
        console.info('Tournament - render called.', this.state);

        if (!this.state.data) {
            return this.renderEmptyState();
        }
        let leaderboard = this.state.data;

        let playerGroups = this.renderPlayerGroupList(leaderboard);
        // let players = this.renderPlayers(leaderboard.players);
        return (<div>
            {/*<button onClick={() => this.props.history.push("/tournaments")}>Tournaments</button>*/}
            <br />
            <br />
            {leaderboard.name}
            {playerGroups}

        </div>);


    }


    renderPlayerGroupList(leaderboard) {
        if (!leaderboard || !leaderboard.groups) {

            return null;
        }

        var items = [];
        var index = 1;
        leaderboard.groups.forEach(element => {


        
            var haslastitem = false; //TODO
            var group = {};
            group.players = element.players;
            group.name = "group " + index;
            group.id = element.id;
            group.tid = leaderboard.id;
            
            items.push(<PlayerGroupItem key={index++} data={element} onclick={this.selectPlayerGroup} haslastitem={haslastitem} />);

        });

        return items;
    }
    renderEmptyState() {
        return (<div><button onClick={() => this.props.history.push("/tournaments")}>Tournaments</button>
            <br />
            <span>loading...</span></div>);
    }



    renderPlayers(array) {
        if (!array) {
            return null;
        }
        var i = 0;
        const items = array.map(x => <PlayerItem key={i++} data={x} onclick={this.selectPlayer} />);

        return items;
    }

    fetchTournament(id) {
        console.log("fetch tournament with id:" + id);
        //http://134.209.230.231:8080/leaderboard/1
        let url = Constants.SERVER + "/leaderboard/" + id;
        fetch(url)
            .then(response => response.json())
            .then(data => {

                // var players = data.leaderboard.players;
                // var map = {};
                // players.forEach(element => {
                //     map[element.id] = element;
                // });

                // data.leaderboard.players = map;

                this.setState({ data })
            }


            ).catch((error) => {
                console.log("error when fetchTournament", url);
                console.error(error);
            });;
    }

    selectPlayer(data) {

        console.log("selectPlayer", data);
    }

    selectPlayerGroup(data) {

        this.props.history.push("/playergroup?tid=" + this._tid + "&id=" + data.id);

    }
}

/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => ({
    userData: state.userData,
    leaderboardData: state.leaderboard,

});

/**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
const mapActionsToProps = {

};

export default connect(mapStateToProps, mapActionsToProps)(Tournament);



// WEBPACK FOOTER //
// ./src/Components/Tournament/index.js